import { getYoutubeVideoId } from '@/utils/get-video';
import { useTranslations } from 'next-intl';

export default function DecisionPopup({ text, videoLink }: { text: string; videoLink?: string }) {
    const t = useTranslations('Common');

    return (
        <div className="flex flex-col gap-12 p-12 pt-5 bg-black border border-white max-w-[940px] w-full max-lg:px-3 mx-auto">
            <h4 className="uppercase text-white text-h5 lg:text-[46px]">{t('juryDecision')}</h4>
            <p className="text-[14px] lg:text-md font-helvetica-neue font-light text-gray-200">
                {text}
            </p>

            {videoLink && (
                <div className="mt-2">
                    <iframe
                        width="100%"
                        height="400"
                        src={`https://www.youtube.com/embed/${getYoutubeVideoId(videoLink)}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            )}
        </div>
    );
}
